module.exports = __webpack_public_path__ + "img/VA1.8b62ea8a.jpeg";